// extracted by mini-css-extract-plugin
export default {"pl1":"LoaderSmall_pl1__NX4yg","pl1__a":"LoaderSmall_pl1__a__p7rfX","pl1__b":"LoaderSmall_pl1__b__v9xLB","pl1__c":"LoaderSmall_pl1__c__kSpdU","bounce1":"LoaderSmall_bounce1__fwGmO"};